<script>
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
@Component({
  //   name: "multiline-dialog"
})
export default class multilineDialog extends Vue {
  @Prop({ type: Array, default: () => [] }) options;
  @Prop({ type: String, default: "flex" }) type;
  @Prop(String) title;
  @Prop({ type: String, default: "large" }) size;
  @Prop(String) width;
  @Prop({ type: Boolean, default: true }) isShowBtn;
  @Prop({ type: Boolean, default: false }) cancelHook;
  @Prop({ type: String, default: '取消' }) cancelText;
  @Prop({ type: String, default: '确定' }) confirmText;
  @Prop({ type: Boolean, default: false }) destroyOnClose;
  @Prop({ type: Boolean, default: false }) confrimBtnDisabled;
  @Prop({ type: String, default: 'default' }) btnType;
  @Prop({ type: Boolean, default: false }) confrimBtnloading;
  @Prop({ type: Boolean, default: true }) modal;
  @Prop({ type: Boolean, default: true }) clickModalClose;

  // @Emit("handleSave")
  // handleSave() {}

  get _width() { // 兼容旧代码
    if(this.width) {
      return this.width
    } else if(this.size) {
      return this.sizeToWidth[this.size] || '50%'
    } else {
      return '50%'
    }
  }

  sizeToWidth = {
    tiny: '30%',
    small: '50%',
    large: '90%',
    full: '100%'
  }

  isShow = false;
  buttonList = [];
  handleSave() {
    this.$emit("handleSave", () => {
      this.handleIsShow(false);
    });
  }
  handleIsShow(type) {
    this.isShow = type;
  }
  mounted() {
    this.buttonList = [
      {
        label: this.cancelText,
        handle: () => {
          if (this.cancelHook === true) {
            return this.$emit("handleCancel", () => {
              this.handleIsShow(false);
            });
          }
          this.$emit("handleCancel");
          this.handleIsShow(false);
        }
      },
      {
        label: this.confirmText,
        type: this.btnType,
        disabled: () => {
          return this.confrimBtnDisabled
        },
        loading: () => {
          return this.confrimBtnloading
        },
        handle: () => {
          this.$emit("handleSave", () => {
            this.handleIsShow(false);
          });
        }
      }
    ];
  }
  render(h) {
    return (
      <el-dialog
        {...{
          on: {
            "update:visible": page => {
              this.isShow = page;
            },
            "close": page => {
              this.$emit("close");
            },
            "open": page => {
              this.$emit("open");
            },
          }
        }}
        width={this._width}
        visible={this.isShow}
        title={this.title}
        destroyOnClose={this.destroyOnClose}
        modal={this.modal}
        close-on-click-modal={this.clickModalClose}
      >
        {this.isShow === true && this.$slots.default}
        <div slot="footer" class="multi-dialog-footer">
          {this.isShowBtn === true ? (
            this.options.length > 0 ? (
              <multiline-button options={this.options}></multiline-button>
            ) : (
              <multiline-button options={this.buttonList}></multiline-button>
            )
          ) : null}
        </div>
      </el-dialog>
    );
  }
}
</script>
<style>
.multi-dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
